
import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
const acc = new Accordion('.accordion-container');
acc.open(0);
